import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import CustomInputBoxAdmin from "../../components/Input";
import CustomDropDown from "../../components/DropDown";

const allChargesSchema: Record<string, string[]> = {
  fuel_surcharge: [
    // "agreementValue",
    // "currentValue",
    "percentageCharge",
    "selectCharge",
  ],
  currency_adjustment_charge: [
    // "agreementValue",
    // "currentValue",
    "absoluteCharge",
    "percentageCharge",
    "conditionType",
    "selectCharge",
  ],
  oda: ["absoluteCharge", "conditionType", "selectCharge", "perKgCharge"],
  opa: ["absoluteCharge", "conditionType", "selectCharge", "perKgCharge"],
  green_tax: ["absoluteCharge"],
  kerala_tax: [
    "absoluteCharge",
    "percentageCharge",
    "conditionType",
    "selectCharge",
    "perKgCharge",
  ],
  reverse_pickup: [
    "absoluteCharge",
    "percentageCharge",
    "conditionType",
    "selectCharge",
    "perKgCharge",
  ],
  misc_docket: ["absoluteCharge"],
  fov_rov: [
    "absoluteCharge",
    "percentageCharge",
    "conditionType",
    "selectCharge",
  ], // FOV/ROV Charges (combined)
  demurrage: [
    "thresholdDays",
    "absoluteCharge",
    "selectCondition",
    "perDayCharge",
    "conditionType",
  ],
  reattempt_charge: [
    "absoluteCharge",
    "percentageCharge",
    "conditionType",
    "selectCharge",
    "perKgCharge",
  ],
  holiday: [
    "absoluteCharge",
    "percentageCharge",
    "conditionType",
    "selectCharge",
    "perKgCharge",
  ],
  peak: ["absoluteCharge", "percentageCharge", "conditionType", "selectCharge"],
  // misc: ["absoluteCharge"],
  handling_charge: ["selectCharge", "perKgCharge", "absoluteCharge"],
  appointment: [
    "absoluteCharge",
    "selectCharge",
    "perKgCharge",
    "conditionType",
  ],
  multistory: ["absoluteCharge", "selectCharge", "perKgCharge"],
  pod: ["absoluteCharge"],
  topay: [
    "absoluteCharge",
    "percentageCharge",
    "conditionType",
    "selectCharge",
  ],
};
const DisplayAllCharges = ({
  businessType,

  summaryVariableCharges = [],
  isSummary = false,
}: any) => {
  const [charges, setCharges] = React.useState<any[]>([]);

  // const dataApi: any = [
  //   {
  //     chargeType: "FUEL_SURCHARGE",
  //     chargeName: "Fuel Surcharge",
  //     percentageCharge: 34,
  //     absoluteCharge: 53,
  //     selectCharge: "Invoice",
  //     selectValue: "Lower",
  //   },
  //   {
  //     chargeType: "CURRENCY_ADJUSTMENT",
  //     chargeName: "Currency Adjustment Charges",
  //     percentageCharge: 32,
  //     absoluteCharge: 22,
  //   },
  //   {
  //     chargeType: "TO_PAY_CHARGES",
  //     chargeName: "To-Pay Charges",
  //     percentageCharge: 323,
  //     absoluteCharge: 334,
  //   },
  // ];

  useEffect(() => {
    let updatedCharges: any = [];
    console.log("summaryVariableCharges", summaryVariableCharges);
    if (summaryVariableCharges.length > 0) {
      // Normalize conditionType and selectCharge values from API format to display format
      updatedCharges = summaryVariableCharges.map((charge: any) => {
        const normalizedCharge = { ...charge };

        // Map conditionType: HIGHER -> Higher, LOWER -> Lower
        if (normalizedCharge.conditionType) {
          const conditionTypeMap: Record<string, string> = {
            HIGHER: "Higher",
            LOWER: "Lower",
            Higher: "Higher",
            Lower: "Lower",
          };
          const mappedConditionType =
            conditionTypeMap[normalizedCharge.conditionType];
          if (mappedConditionType) {
            normalizedCharge.conditionType = mappedConditionType;
          } else {
            // Fallback: capitalize first letter, lowercase rest
            const value = String(normalizedCharge.conditionType);
            normalizedCharge.conditionType =
              value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
          }
        }

        // Map selectCharge: FREIGHT -> Freight, WEIGHT -> Weight, INVOICE -> Invoice
        if (normalizedCharge.selectCharge) {
          const selectChargeMap: Record<string, string> = {
            FREIGHT: "Freight",
            WEIGHT: "Weight",
            INVOICE: "Invoice",
            Freight: "Freight",
            Weight: "Weight",
            Invoice: "Invoice",
          };
          const mappedSelectCharge =
            selectChargeMap[normalizedCharge.selectCharge];
          if (mappedSelectCharge) {
            normalizedCharge.selectCharge = mappedSelectCharge;
          } else {
            // Fallback: capitalize first letter, lowercase rest
            const value = String(normalizedCharge.selectCharge);
            normalizedCharge.selectCharge =
              value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
          }
        }

        return normalizedCharge;
      });
    } else {
      updatedCharges = charges;
    }
    setCharges(updatedCharges);
  }, [summaryVariableCharges]);
  const percentageOptions = [
    { label: "Higher", value: "Higher" },
    { label: "Lower", value: "Lower" },
  ];
  const selectChargeOptions = [
    { label: "Freight", value: "Freight" },
    { label: "Weight", value: "Weight" },
    { label: "Invoice", value: "Invoice" },
  ];
  const selectConditionOptions = [
    { label: "Per Kg per floor charge", value: "PER_KG_PER_FLOOR" },
    // { label: "Per day charge", value: "PER_DAY_CHARGE" },
  ];

  // Mapping of charge types to their restricted default selectCharge option
  const restrictedSelectChargeOptions: Record<string, string> = {
    fuel_surcharge: "Freight",
    currency_adjustment_charge: "Freight",
    fov_rov: "Invoice",
    peak: "Freight",
    handling_charge: "Weight",
    multistory: "Weight",
    topay: "Freight",
  };

  // Helper function to normalize conditionType value for display
  const normalizeConditionType = (value: string | undefined | null): string => {
    if (!value) return "";
    const conditionTypeMap: Record<string, string> = {
      HIGHER: "Higher",
      LOWER: "Lower",
      Higher: "Higher",
      Lower: "Lower",
    };
    return (
      conditionTypeMap[value] ||
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    );
  };

  // Helper function to normalize selectCharge value for display
  const normalizeSelectCharge = (value: string | undefined | null): string => {
    if (!value) return "";
    const selectChargeMap: Record<string, string> = {
      FREIGHT: "Freight",
      WEIGHT: "Weight",
      INVOICE: "Invoice",
      Freight: "Freight",
      Weight: "Weight",
      Invoice: "Invoice",
    };
    return (
      selectChargeMap[value] ||
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    );
  };

  // Helper function to get selectCharge options for a specific charge type
  const getSelectChargeOptions = (chargeType: string) => {
    const chargeKey = chargeType?.toLowerCase() || "";
    const restrictedOption = restrictedSelectChargeOptions[chargeKey];

    if (restrictedOption) {
      // Return only the default option for restricted charges
      return [{ label: restrictedOption, value: restrictedOption }];
    }

    // For all non-restricted charges, exclude "Invoice" option (only FOV/ROV can have Invoice)
    // Return only "Freight" and "Weight" options
    return [
      { label: "Freight", value: "Freight" },
      { label: "Weight", value: "Weight" },
    ];
  };
  return (
    <div className="pb-28 font-Open">
      {isSummary && charges?.length > 0 ? (
        <div>
          <div className="mb-4">
            <div className="text-2xl mb-3">Variable Charges</div>
            <p className="text-[#606060]">
              Variable Charges are condition-based fees (e.g., fuel, weight,
              COD) that auto-adjust per order. You can modify them as needed.
            </p>
          </div>
          {charges.map((charge) => (
            <div
              key={charge.chargeType.toLowerCase() || ""}
              className="bg-blue-300 rounded-2xl ps-1.5 mb-4"
            >
              {charge.chargeType.toLowerCase() != "INSURANCE".toLowerCase() && (
                <div className="w-full flex h-[100px] flex-col md:flex-row rounded-2xl p-5 bg-white shadow gap-6 items-center">
                  {/* Charge Label */}
                  <div className="flex items-center gap-3 md:min-w-[220px] lg:w-80 md:w-60">
                    <div className="text-sm">{charge.chargeName}</div>
                  </div>

                  {/* Dynamic Fields */}
                  <div className="flex-1 w-full">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-6 items-center">
                      {(
                        allChargesSchema[
                          charge.chargeType.toLowerCase() || ""
                        ] ?? []
                      )
                        .filter((field: string) => {
                          if (field === "perKgCharge") {
                            const sel = String(
                              charge.selectCharge ?? "",
                            ).toUpperCase();
                            if (
                              charge.selectCharge === "Weight" ||
                              sel === "WEIGHT"
                            ) {
                              return true;
                            }
                            // Plan/API often sends perKgCharge without selectCharge (e.g. B2B variables)
                            if (isSummary) {
                              const v = charge.perKgCharge;
                              if (v != null && v !== "") return true;
                            }
                            return false;
                          }
                          return true;
                        })
                        .flatMap((field: string, index: number) => {
                          const chargeFields =
                            allChargesSchema[
                              charge.chargeType.toLowerCase() || ""
                            ] ?? [];
                          const elements: any[] = [];

                          // Add "Or" separator for demurrage between absoluteCharge and selectCondition
                          if (
                            charge.chargeType?.toLowerCase() === "demurrage" &&
                            field === "selectCondition"
                          ) {
                            const previousFieldIndex = index - 1;
                            if (previousFieldIndex >= 0) {
                              const previousField =
                                chargeFields[previousFieldIndex];
                              if (
                                previousField === "absoluteCharge" ||
                                previousField === "thresholdDays"
                              ) {
                                elements.push(
                                  <div
                                    key={`or-${index}`}
                                    className="flex items-center justify-center text-sm font-medium text-gray-600"
                                  >
                                    Or
                                  </div>,
                                );
                              }
                            }
                          }

                          // Add "Or" separator for fov_rov between absoluteCharge and percentageCharge
                          if (
                            charge.chargeType?.toLowerCase() === "fov_rov" &&
                            field === "percentageCharge"
                          ) {
                            const previousFieldIndex = index - 1;
                            if (previousFieldIndex >= 0) {
                              const previousField =
                                chargeFields[previousFieldIndex];
                              if (previousField === "absoluteCharge") {
                                elements.push(
                                  <div
                                    key={`or-${index}`}
                                    className="flex items-center justify-center text-sm font-medium text-gray-600"
                                  >
                                    Or
                                  </div>,
                                );
                              }
                            }
                          }

                          if (
                            field === "conditionType" ||
                            field === "selectCharge" ||
                            field === "selectCondition"
                          ) {
                            elements.push(
                              <CustomDropDown
                                key={field}
                                disabled={isSummary}
                                value={
                                  field === "conditionType"
                                    ? normalizeConditionType(charge[field])
                                    : field === "selectCharge"
                                      ? normalizeSelectCharge(charge[field])
                                      : (charge[field] ?? "")
                                }
                                onChange={(e) => {
                                  setCharges((prev) =>
                                    prev.map((c) =>
                                      c.chargeType.toLowerCase() ===
                                      charge.chargeType.toLowerCase()
                                        ? { ...c, [field]: e.target.value }
                                        : c,
                                    ),
                                  );
                                }}
                                selectClassName="border !rounded-xl px-3 py-2 text-sm bg-white"
                                options={
                                  field === "conditionType"
                                    ? percentageOptions
                                    : field === "selectCondition"
                                      ? selectConditionOptions
                                      : field === "selectCharge"
                                        ? getSelectChargeOptions(
                                            charge.chargeType,
                                          )
                                        : selectChargeOptions
                                }
                              />,
                            );
                          } else {
                            elements.push(
                              <CustomInputBoxAdmin
                                key={field}
                                label={
                                  field === "thresholdDays" &&
                                  charge.chargeType?.toLowerCase() ===
                                    "demurrage"
                                    ? "Threshold Days after 1st OFD"
                                    : field
                                }
                                isDisabled={isSummary}
                                inputType="number"
                                value={charge[field] ?? ""}
                                onChange={(e: any) => {
                                  const inputValue = e.target.value;

                                  // Validation for absoluteCharge, percentageCharge, perKgCharge, and perDayCharge: cannot be zero
                                  // Note: percentageCharge can be 0 for fuel_surcharge
                                  if (
                                    (field === "absoluteCharge" ||
                                      field === "percentageCharge" ||
                                      field === "perKgCharge" ||
                                      field === "perDayCharge") &&
                                    inputValue !== ""
                                  ) {
                                    const numValue = parseFloat(inputValue);
                                    // Allow zero for percentageCharge if it's fuel_surcharge
                                    const isFuelSurchargePercentage =
                                      field === "percentageCharge" &&
                                      charge.chargeType?.toLowerCase() ===
                                        "fuel_surcharge";
                                    if (
                                      !isNaN(numValue) &&
                                      numValue === 0 &&
                                      !isFuelSurchargePercentage
                                    ) {
                                      const fieldLabel =
                                        field === "absoluteCharge"
                                          ? "Absolute"
                                          : field === "percentageCharge"
                                            ? "Percentage"
                                            : field === "perKgCharge"
                                              ? "Per Kg"
                                              : "Per Day";
                                      toast.error(
                                        `${fieldLabel} charge cannot be zero`,
                                      );
                                      return; // Don't update if value is zero
                                    }
                                  }

                                  // Validation for percentageCharge: cannot exceed 100
                                  if (
                                    field === "percentageCharge" &&
                                    inputValue !== ""
                                  ) {
                                    const numValue = parseFloat(inputValue);
                                    if (!isNaN(numValue) && numValue > 100) {
                                      toast.error(
                                        "Percentage charge cannot exceed 100",
                                      );
                                      return; // Don't update if value exceeds 100
                                    }
                                  }

                                  setCharges((prev) =>
                                    prev.map((c) =>
                                      c.chargeType.toLowerCase() ===
                                      charge.chargeType.toLowerCase()
                                        ? { ...c, [field]: inputValue }
                                        : c,
                                    ),
                                  );
                                }}
                                className="border  !rounded-xl px-3 w-full text-sm"
                                inputClassName="!rounded-xl"
                              />,
                            );
                          }

                          return elements;
                        })}
                    </div>
                  </div>
                </div>
              )}
              {charge.chargeType.toLowerCase() ===
                "INSURANCE".toLowerCase() && (
                <div className="bg-blue-300 rounded-2xl  mb-4">
                  <div className="w-full flex flex-col md:flex-row rounded-2xl p-5 bg-white shadow gap-6 items-start">
                    {/* Charge Label */}
                    <div className="flex items-center gap-3 md:min-w-[220px] lg:w-80 md:w-60 pt-2">
                      <div className="text-sm font-medium">
                        Insurance Charges
                      </div>
                    </div>

                    {/* Dynamic Fields */}
                    <div className="flex-1 pe-10 w-full flex flex-col gap-4">
                      {Array.isArray(charge?.insurance) &&
                        charge.insurance.map((row: any, i: any) => (
                          <div
                            key={i}
                            className="flex flex-col md:flex-row items-center gap-4"
                          >
                            <CustomInputBoxAdmin
                              isDisabled={isSummary}
                              className="border rounded-xl p-2 w-24"
                              label="Premium %"
                              value={row.premium}
                              placeholder="Premium %"
                              onChange={(e) => {}}
                              inputType="number"
                            />

                            <div className="text-sm font-medium whitespace-nowrap">
                              for Invoice value between
                            </div>

                            <CustomInputBoxAdmin
                              isDisabled={isSummary}
                              label="From Amount (₹)"
                              className="border rounded-xl p-2 w-24"
                              value={row.from}
                              placeholder="From Amount (₹)"
                              onChange={(e) => {}}
                              inputType="number"
                            />

                            <div className="text-sm font-medium">And</div>

                            <CustomInputBoxAdmin
                              isDisabled={isSummary}
                              className="border rounded-xl p-2 w-24"
                              value={row.to}
                              label="To Amount (₹)"
                              placeholder="To Amount (₹)"
                              onChange={(e) => {}}
                              inputType="number"
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="w-full  flex justify-center items-center h-[40vh] text-gray-500 text-sm font-medium bg-gray-50 rounded-2xl p-5">
          No Variable Charges present
        </div>
      )}
    </div>
  );
};

export default DisplayAllCharges;
